// extracted by mini-css-extract-plugin
module.exports = {"link":"TextLink_link__3u8jv","noWrapLink":"TextLink_noWrapLink__1LYr-","button":"TextLink_button__3XwWm"};